import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef
} from "@angular/core";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { NgTemplateOutlet } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-dialog-header",
  templateUrl: "./dialog-header.component.html",
  styleUrls: ["./dialog-header.component.scss"],
  imports: [
    MatToolbar,
    MatToolbarRow,
    MatIconButton,
    MatIcon,
    NgTemplateOutlet,
    TranslatePipe
  ]
})
export class DialogHeaderComponent {
  @Input() title: string = "";
  @Input() titleTranslateKey: string = "";
  @Input() showCloseButton: boolean = true;
  @Input() showAuditButton: boolean = false;
  @Input() auditDisabled: boolean = false;
  @Input() additionalContent: TemplateRef<any> | null = null;
  @Input() titlePrefixContent: TemplateRef<any> | null = null;
  @Output() closeClicked = new EventEmitter<void>();
  @Output() auditClicked = new EventEmitter<void>();
  @Output() titleClicked = new EventEmitter<void>();

  onCloseClick() {
    this.closeClicked.emit();
  }

  onAuditClick() {
    this.auditClicked.emit();
  }
}
